import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full h-screen flex justify-center items-center bg-gray-50" }
const _hoisted_2 = ["id", "src"]
const _hoisted_3 = { class: "absolute bottom-12 text-xl font-light tracking-wider left-0 text-center w-full" }
const _hoisted_4 = { class: "absolute w-full text-center bottom-10 left-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "relative overflow-hidden",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startAnimation && _ctx.startAnimation(...args))),
      style: {"width":"1000px","height":"1000px"}
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, imageIdx) => {
        return (_openBlock(), _createBlock(_Transition, {
          key: imageIdx,
          name: (_ctx.aniVersion === 'fade') ? 'bounce': ''
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("img", {
                class: "absolute inset-0",
                id: 'animation-' + imageIdx,
                alt: "",
                src: '/ani/symposium/' + image
              }, null, 8, _hoisted_2),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", {
                  class: _normalizeClass(["mx-auto", {
                'text-white py-2 px-3 bg-red-700 rounded-3xl text-4xl relative bottom-52 mx-auto font-bold': image.includes('Herrenringe'),
                'text-white py-2 px-3 bg-red-700 rounded-3xl text-4xl relative bottom-48 left-12 font-bold': _ctx.getText(image).includes('€') && !image.includes('Herrenring')
              }])
                }, _toDisplayString(_ctx.getText(image)), 3)
              ])
            ], 512), [
              [_vShow, imageIdx === _ctx.curImageIdx]
            ])
          ]),
          _: 2
        }, 1032, ["name"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.curImageIdx), 1)
  ]))
}